import { z } from "zod";
import { labelSchema, timestampSchema } from "./primitives.js";
/** Upper bound of resources in one inventory snapshot. */
export const INVENTORY_MAX_RESOURCES = 50_000;
/** Resource types collected by the inventory utility. */
export const INVENTORY_RESOURCE_TYPES = [
    "SERVER",
    "STORAGE",
    "BACKUP",
    "IP_ADDRESS",
    "MANAGED_DATABASE",
    "MANAGED_OBJECT_STORAGE",
    "MANAGED_LOADBALANCER",
    "NETWORK_GATEWAY",
    "KUBERNETES_CLUSTER",
];
export const inventoryResourceTypeSchema = z.enum(INVENTORY_RESOURCE_TYPES);
/** How a resource relates to its parent. */
export const ASSOCIATION_KINDS = ["ATTACHED", "BACKUP_OF", "ASSIGNED"];
export const associationKindSchema = z.enum(ASSOCIATION_KINDS);
/** UpCloud resource identifier: a UUID, or an IP address for IP resources. */
export const upcloudResourceIdSchema = z.union([z.uuid(), z.ipv4(), z.ipv6()]);
const optionalText = z.string().max(255).nullable();
export const inventoryResourceSchema = z.object({
    resourceId: upcloudResourceIdSchema,
    type: inventoryResourceTypeSchema,
    title: optionalText,
    hostname: optionalText,
    zone: z.string().max(32).nullable(),
    labels: z.array(labelSchema).max(100),
    parent: z
        .object({
        resourceId: upcloudResourceIdSchema,
        kind: associationKindSchema,
    })
        .nullable(),
    kubernetesClusterId: z.uuid().nullable(),
});
/** Inventory snapshot uploaded by the inventory utility with `PUT /api/v1/inventory`. */
export const inventorySnapshotSchema = z.object({
    capturedAt: timestampSchema,
    resources: z.array(inventoryResourceSchema).max(INVENTORY_MAX_RESOURCES),
});
export const inventoryUploadResponseSchema = z.object({
    inventoryUploadId: z.uuid(),
    resourceCount: z.number().int().nonnegative(),
    associationCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=inventory.js.map